import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Loading from "components/HomeRepairFunnelV2/Components/Loading";
import HomeRepairManagementLayout from "components/layouts/HomeRepairManagementLayout";

const HomeRepairPortal = () => {
  const router = useRouter();
  useEffect(() => {
    router.push("/ma-reparation/rendez-vous/");
  });
  return <Loading />;
};

HomeRepairPortal.getLayout = function getLayout(page: any) {
  return <HomeRepairManagementLayout>{page}</HomeRepairManagementLayout>;
};

export default HomeRepairPortal;
